import React from "react";
import { Link } from "react-router-dom";
import { FiCheck } from "react-icons/fi";

/* NOTE: these tiers and prices are placeholders carried over from
   early planning and need sign-off before launch. Swap in confirmed
   pricing and inclusions before this page goes live. */
const tiers = [
  { name: "Essentials", price: "₹199", unit: "per guest", description: "A simple, well-decorated party for smaller gatherings.", features: ["Balloon & theme decor", "Classic cake", "Return gifts for guests", "Delivered to your door"] },
  { name: "Classic", price: "₹299", unit: "per guest", description: "Richer decor and a fuller spread for a livelier party.", features: ["Theme-based decor set", "Custom cake", "Snacks & catering combo", "Delivered to your door"], highlighted: true },
  { name: "Premium", price: "₹499", unit: "per guest", description: "Elevated styling and catering, with the day captured properly.", features: ["Premium decor collection", "Multi-tier custom cake", "Extended catering spread", "Photography coverage"] },
  { name: "Signature", price: "₹799", unit: "per guest", description: "Our most complete birthday, curated end to end.", features: ["Signature decor collection", "Designer custom cake", "Premium catering spread", "Full photo & video coverage"] },
];

const Packages = () => {
  return (
    <section className="bg-cloud py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <div className="max-w-prose">
          <h2 className="text-3xl font-bold text-brand sm:text-4xl">Packages</h2>
          <p className="mt-4 text-muted">
            Priced per guest, so the total scales with your party size.
            Curated from our network of verified partners and delivered
            ready for the celebration — your exact quote depends on guest
            count, location, and any customization.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className={`flex flex-col rounded-2xl p-6 ${
                tier.highlighted ? "bg-brand text-paper" : "bg-paper text-charcoal border border-line"
              }`}
            >
              {tier.highlighted && (
                <span className="mb-3 inline-flex w-fit items-center rounded-full bg-gold px-2.5 py-1 text-[11px] font-semibold text-brand">
                  Most popular
                </span>
              )}
              <h3 className="text-lg font-semibold">{tier.name}</h3>
              <p className={`mt-3 text-3xl font-bold ${tier.highlighted ? "text-paper" : "text-brand"}`}>
                {tier.price}
                <span className={`ml-1 text-sm font-normal ${tier.highlighted ? "text-paper/70" : "text-muted"}`}>
                  /{tier.unit}
                </span>
              </p>
              <p className={`mt-2 text-sm ${tier.highlighted ? "text-paper/85" : "text-muted"}`}>
                {tier.description}
              </p>

              <ul className="mt-6 space-y-2.5 text-sm">
                {tier.features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <FiCheck className={`mt-0.5 shrink-0 ${tier.highlighted ? "text-gold" : "text-action"}`} size={16} />
                    <span className={tier.highlighted ? "text-paper/90" : "text-muted"}>{f}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/book"
                className={`mt-8 inline-flex items-center justify-center rounded-full px-5 py-3 text-sm font-medium transition-colors ${
                  tier.highlighted ? "bg-paper text-brand hover:bg-paper/90" : "bg-action text-paper hover:bg-action/90"
                }`}
              >
                Choose {tier.name}
              </Link>
            </div>
          ))}
        </div>

        <p className="mt-10 text-sm text-muted">
          Prices shown are a starting guide — request a quote for the exact
          number for your event.
        </p>
      </div>
    </section>
  );
};

export default Packages;
